(() => {
  'use strict';

  if (window.PWNativeCollectionSortLoaded) return;
  window.PWNativeCollectionSortLoaded = true;

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-pw-native-sort]')) return;

    event.stopImmediatePropagation();

    const value = String(select.value || '').trim();
    if (!value) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    url.hash = 'products-toolbar';
    window.location.assign(url.toString());
  }, true);
})();
